import React from 'react';
import {Link} from 'react-router';
import moment from 'moment';
import 'moment-timezone';
import withRouter from '../utils/with-router';

@withRouter
class EditShiftHeader extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
        }
    }

    getBackLink(status, shiftId) {
        if (shiftId) {
            return <Link to="shift" params={{shiftId: shiftId}} className="arrow-container"><div className="arrow"></div></Link>
        } else {
            return <Link to="agenda" className="arrow-container"><div className="arrow"></div></Link>
        }
    }

    getCancelLink(status, shiftId) {
        if (shiftId) {
            return <Link to="shift" params={{shiftId: shiftId}} className="btn-cancel btn-transparent">BACK</Link>
        } else {
            return <Link to="agenda" className="btn-cancel btn-transparent">BACK</Link>
        }
    }

    renderButtons(shift) {
        if (shift.status === 'draft'){
            return [1, 2].map(id => {
                if ( id === 1 ){
                    return <button
                        onClick={this.props.saveDraft}
                        className={"btn btn-small btn-save-shift btn-green"}>Save</button>;
                } else {

                    if (this.props.user.can_apply) {
                        return <button
                            onClick={this.props.saveShift}
                            className={"btn btn-small btn-save-shift" + (this.props.publishReady ? " btn-green" : " btn-gray ")}
                            disabled={!this.props.publishReady}>Publish</button>;
                    } else {
                        return <button
                            className="btn btn-small btn-save-shift btn-gray btn-tooltip"
                            disabled>Publish<div className="btn-tooltip-content">User not active</div></button>;
                    }
                }
            })
        } else {
            return <button
                onClick={this.props.saveShift}
                className={"btn btn-small btn-save-shift" + (this.props.changed ? " btn-green" : " btn-gray ")}
                disabled={!this.props.changed}>Save</button>;
        }
    }

    render () {
        const shift = this.props.shift || {};
        const position = this.props.shift.position || {};

        const namePieces = [
            position.name !== undefined ? shift.workers_needed : '',
            position.name !== undefined ? shift.position.name : '',
            position.name && shift.workers_needed ? '-' : '',
            shift.venue + ' ' + moment(shift.start_time).tz(shift.company.timezone).format('DD.MM.YYYY H:mm')
        ];

        return (
            <header className="edit-shift-header">
                <div className="maxwidth-wrapper">
                    <div className="left">
                        {this.getBackLink(shift.status, shift.id)}
                        <h1 className="page-title">Edit Shift</h1>
                        <span className="page-description">{namePieces.join(' ')}</span>
                    </div>
                    <div className="right">
                        {this.getCancelLink(shift.status, shift.id)}
                        {this.renderButtons(shift)}
                    </div>
                </div>
            </header>
        );
    }

}

export default EditShiftHeader;



/** WEBPACK FOOTER **
 ** ./app/src/components/EditShiftHeader.js
 **/